export default __webpack_public_path__ + "static/media/StepTwo.65dc1545.png";